import { useEffect } from "react";

const useClickOutside = (ref, handler, bindTarget: Element | Document = document, disabled = false) => {
   useEffect(() => {
      if (disabled) {
         return;
      }

      let startedInside = false;
      let startedWhenMounted = false;
      const listener = (event) => {
         // Do nothing if `mousedown` or `touchstart` started inside ref element
         if (startedInside || !startedWhenMounted) return;
         // Do nothing if clicking ref's element or descendent elements
         if (!ref.current || ref.current.contains(event.target)) return;

         handler(event);
      };

      const validateEventStart = (event) => {
         startedWhenMounted = ref.current;
         startedInside = ref.current && ref.current.contains(event.target);
      };

      bindTarget.addEventListener("mousedown", validateEventStart);
      bindTarget.addEventListener("touchstart", validateEventStart);
      bindTarget.addEventListener("click", listener);

      return () => {
         bindTarget.removeEventListener("mousedown", validateEventStart);
         bindTarget.removeEventListener("touchstart", validateEventStart);
         bindTarget.removeEventListener("click", listener);
      };
   }, [ref, handler, bindTarget, disabled]);
};

export default useClickOutside;